import t from"react";const e=t=>t;function r(r,n=e){const o=t.useSyncExternalStore(r.subscribe,(()=>n(r.getState())),(()=>n(r.getInitialState())));return t.useDebugValue(o),o}export{r as useStore};
